module.exports = __webpack_public_path__ + "img/LV44103018793.7f7a068e.png";